module.exports = __webpack_public_path__ + "static/media/slide_3.89720ad0.svg";